import React from 'react';
import styles from './styles.module.scss';

interface Props {
    company?: 'DBS' | 'AWS';
    description: string;
}

const IndustryColumn = (props: Props) => {
    let imageSrc = '';
    switch (props.company) {
        case 'DBS':
            imageSrc = '/static/images/svg/logo_DBS.svg';
            break;
        case 'AWS':
            imageSrc = '/static/images/svg/logo_aws.svg';
            break;
        default:
            break;
    }
    return (
        <div className={styles.container}>
            <img src={imageSrc} className={styles.logo} />
            <p className={styles.description}>{props.description}</p>
        </div>
    );
};

IndustryColumn.defaultProps = {
    company: '',
};

export default IndustryColumn;
